import {
  IotToolbarDefaultButtonConfig,
  IotToolbarDispatchActionType,
  IotToolbarMenuButtonConfig,
  IotToolbarRegularButtonConfig,
  menuButtonBaseConfig,
  regularButtonBaseConfig,
  toggleButtonBaseConfig
} from '@iot-platform/iot-platform-ui';

const toggleDataGuardButtonConfig: Partial<IotToolbarDefaultButtonConfig> = {
  ...toggleButtonBaseConfig,
  dispatchAction: { options: undefined, type: IotToolbarDispatchActionType.TOGGLE_DATA_GUARD },
  icon: undefined,
  svgIcon: 'data_guard',
  tooltip: 'IOT_TOOLBAR.TOOLTIP.TOGGLE_DATA_GUARD',
  badgeColor: 'warn'
};

const toggleCommentsButtonConfig: Partial<IotToolbarDefaultButtonConfig> = {
  ...toggleButtonBaseConfig,
  dispatchAction: { options: undefined, type: IotToolbarDispatchActionType.TOGGLE_COMMENTS },
  icon: 'comment',
  tooltip: 'IOT_TOOLBAR.TOOLTIP.TOGGLE_COMMENTS'
};

const toggleAssetDeviceAssociationsButtonConfig: Partial<IotToolbarDefaultButtonConfig> = {
  ...toggleButtonBaseConfig,
  dispatchAction: { options: undefined, type: IotToolbarDispatchActionType.TOGGLE_ASSOCIATION },
  icon: 'account_tree',
  tooltip: 'IOT_TOOLBAR.TOOLTIP.TOGGLE_ASSOCIATION'
};

const commandsMenuButtonConfig: Partial<IotToolbarMenuButtonConfig> = {
  ...menuButtonBaseConfig,
  icon: 'send',
  tooltip: 'IOT_TOOLBAR.TOOLTIP.COMMANDS',
  displayArrowIcon: true,
  menuOptions: [
    {
      order: 0,
      label: 'DEVICES.CARD.REFRESH',
      dispatchAction: { type: IotToolbarDispatchActionType.SEND_COMMAND_REFRESH }
    },
    {
      order: 1,
      label: 'DEVICES.CARD.UNBLOCK',
      dispatchAction: { type: IotToolbarDispatchActionType.SEND_COMMAND_UNBLOCK }
    },
    {
      order: 2,
      label: 'ASSETS.CARD.THRESHOLD',
      dispatchAction: { type: IotToolbarDispatchActionType.SEND_COMMAND_THRESHOLD }
    },
    {
      order: 3,
      label: 'DEVICES.CARD.GET_ALARM',
      dispatchAction: { type: IotToolbarDispatchActionType.SEND_COMMAND_GET_ALARM }
    },
    {
      order: 4,
      label: 'DEVICES.CARD.SELFCONF',
      dispatchAction: { type: IotToolbarDispatchActionType.SEND_COMMAND_GET_CONFIGURATION }
    }
  ]
};

const assetConfigurationButtonConfig: Partial<IotToolbarMenuButtonConfig> = {
  ...menuButtonBaseConfig,
  icon: 'settings',
  tooltip: 'IOT_TOOLBAR.TOOLTIP.CONFIGURATION',
  displayArrowIcon: true,
  menuOptions: [
    {
      order: 4,
      label: 'ASSETS.CARD.APPLY_TEMPLATE',
      dispatchAction: { type: IotToolbarDispatchActionType.APPLY_TEMPLATE_TO_ASSET }
    },
    {
      order: 5,
      label: 'ASSETS.CARD.CONFIGURE_PRODUCTS',
      dispatchAction: { type: IotToolbarDispatchActionType.CONFIGURE_PRODUCTS }
    },
    {
      order: 6,
      label: 'ASSETS.CARD.REMOVE_PRODUCTS',
      dispatchAction: { type: IotToolbarDispatchActionType.REMOVE_PRODUCTS }
    },
    {
      order: 7,
      divider: true,
      label: 'ASSETS.CARD.EDIT_MAINTENANCE',
      dispatchAction: { type: IotToolbarDispatchActionType.EDIT_MAINTENANCE }
    },
    {
      order: 8,
      label: 'ASSETS.CARD.END_MAINTENANCE',
      dispatchAction: { type: IotToolbarDispatchActionType.END_MAINTENANCE }
    },
    {
      order: 9,
      divider: true,
      label: 'ASSETS.CARD.START_MAINTENANCE',
      dispatchAction: { type: IotToolbarDispatchActionType.START_MAINTENANCE, options: undefined }
    },
    {
      divider: true,
      order: 10,
      label: 'ASSETS.CARD.DECOMMISSION',
      dispatchAction: { type: IotToolbarDispatchActionType.DECOMMISSION },
      style: 'color: #B22222;'
    },
    {
      order: 11,
      label: 'IOT_DICTIONARY.DELETE',
      dispatchAction: { type: IotToolbarDispatchActionType.DELETE_ELEMENT },
      style: 'color: #B22222;'
    }
  ]
};

const deviceConfigurationButtonConfig: Partial<IotToolbarMenuButtonConfig> = {
  ...menuButtonBaseConfig,
  icon: 'settings',
  tooltip: 'IOT_TOOLBAR.TOOLTIP.CONFIGURATION',
  displayArrowIcon: true,
  menuOptions: [
    {
      order: 0,
      label: 'ASSETS.CARD.EDIT_MAINTENANCE',
      dispatchAction: { type: IotToolbarDispatchActionType.EDIT_MAINTENANCE }
    },
    {
      order: 1,
      label: 'ASSETS.CARD.END_MAINTENANCE',
      dispatchAction: { type: IotToolbarDispatchActionType.END_MAINTENANCE }
    },
    {
      order: 2,
      label: 'ASSETS.CARD.START_MAINTENANCE',
      dispatchAction: { type: IotToolbarDispatchActionType.START_MAINTENANCE, options: undefined }
    },
    {
      order: 3,
      divider: true,
      label: 'DEVICES.CARD.MOVE_TO',
      dispatchAction: { type: IotToolbarDispatchActionType.MOVE_TO }
    },
    {
      order: 4,
      label: 'IOT_DICTIONARY.REPLACE',
      dispatchAction: { type: IotToolbarDispatchActionType.REPLACE }
    },
    {
      order: 5,
      label: 'DEVICES.CARD.ACTIVATE',
      dispatchAction: { type: IotToolbarDispatchActionType.ACTIVATE }
    },
    {
      order: 6,
      label: 'DEVICES.CARD.RESET',
      dispatchAction: { type: IotToolbarDispatchActionType.RESET }
    },
    {
      divider: true,
      order: 7,
      label: 'DEVICES.CARD.DECOMMISSION',
      dispatchAction: { type: IotToolbarDispatchActionType.DECOMMISSION },
      style: 'color: #B22222;'
    },
    {
      order: 8,
      label: 'IOT_DICTIONARY.DELETE',
      dispatchAction: { type: IotToolbarDispatchActionType.DELETE_ELEMENT },
      style: 'color: #B22222;'
    }
  ]
};

const deviceConfigureInConnectorButtonConfig: Partial<IotToolbarRegularButtonConfig> = {
  ...regularButtonBaseConfig,
  dispatchAction: { type: IotToolbarDispatchActionType.OPEN_CONNECTOR, options: undefined },
  svgIcon: 'open-connector',
  tooltip: 'DEVICES.TOOLBAR.TOOLTIPS.CONFIGURE_IN_CONNECTOR'
};

export const TOGGLE_DATA_GUARD_BUTTON_CONFIG = new IotToolbarRegularButtonConfig(toggleDataGuardButtonConfig);
export const TOGGLE_COMMENTS_BUTTON_CONFIG = new IotToolbarRegularButtonConfig(toggleCommentsButtonConfig);
export const TOGGLE_ASSET_DEVICE_ASSOCIATIONS_BUTTON_CONFIG = new IotToolbarRegularButtonConfig(toggleAssetDeviceAssociationsButtonConfig);
export const COMMANDS_MENU_BUTTON_CONFIG = new IotToolbarMenuButtonConfig(commandsMenuButtonConfig);
export const ASSET_CONFIGURATION_MENU_BUTTON_CONFIG = new IotToolbarMenuButtonConfig(assetConfigurationButtonConfig);
export const DEVICE_CONFIGURATION_MENU_BUTTON_CONFIG = new IotToolbarMenuButtonConfig(deviceConfigurationButtonConfig);
export const DEVICE_CONFIGURE_IN_CONNECTOR_BUTTON_CONFIG = new IotToolbarRegularButtonConfig(deviceConfigureInConnectorButtonConfig);
